import { Routes, Route } from "react-router-dom";

import Login from "containers/Login/Login";
import Home from "containers/Home/Home";
import StudentDetails from "containers/Student/StudentDetails";
import AuthenticatedRoute from "./components/Routes/AuthenticatedRoutes";
import routes from "constants/routes";
import OrderModification from "./containers/OrderManagement/OrderModification";
import OrderCancellation from "./containers/OrderManagement/OrderCancellation";
import NotFoundPage from "components/ErrorBoundary/NotFoundPage";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path={routes.login.root} element={<Login />} />

      <Route element={<AuthenticatedRoute />}>
        <Route path={routes.home.root} element={<Home />} />
        <Route path={routes.studentDetails} element={<StudentDetails />} />
        <Route path={routes.default} element={<Home />} />
        <Route path={routes.modifyOrder} element={<OrderModification />} />
        <Route path={routes.cancelOrder} element={<OrderCancellation />} />
        <Route path={routes.pageNotFound} element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
